import { cn } from '@/lib/utils';

interface CompanyLogoProps {
  name: string;
  src: string | null;
  size?: number;
  className?: string;
}

/** iOS `ClaimsLogoView`: 12pt rounded image; letter fallback is a circle. */
export function CompanyLogo({ name, src, size = 44, className }: CompanyLogoProps) {
  const letter = (name.trim()[0] || '?').toUpperCase();
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-[12px]',
        className,
      )}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt="" className="size-full object-contain" />
      ) : (
        <span
          className={cn(
            'flex size-full items-center justify-center rounded-full bg-mf-neutral-50 font-bold text-mf-neutral-400',
            size === 44 ? 'font-display text-xl' : 'text-sm',
          )}
        >
          {letter}
        </span>
      )}
    </div>
  );
}
